import {createContext, useContext} from 'react';

interface DataTableContextValue {
  onRowClick?: (row: any) => void;
  rowLinkFunc?: (row: any) => string;
  enableRowSelection?: boolean | ((row: any) => boolean);
  disableRowHover: boolean;
}

const DataTableContext = createContext<DataTableContextValue>({
  disableRowHover: false
});

export function useDataTableContext<TData = unknown>() {
  return useContext(DataTableContext) as {
    onRowClick?: (row: TData) => void;
    rowLinkFunc?: (row: TData) => string;
    enableRowSelection?: boolean | ((row: TData) => boolean);
    disableRowHover: boolean;
  };
}

export default DataTableContext;
